export const PATHS = {
  
  BASE: '/',
  LOADING: 'loading',
  HOME: 'home', 
  UNSUPPORTED: 'unsupported', 

  RATING_ONE: 'rating-one', 
  RATING_TWO: 'rating-two', 
  RATING_THREE: 'rating-three', 
  RATING_FOUR: 'rating-four', 
  RATING_FIVE: 'rating-five'

}
 
export const LOAD = {
  GROUPS: {
    MAIN: 'LOAD:GROUPS:MAIN',
    BUBBLE: 'LOAD:GROUPS:BUBBLE',
    CHARACTER: 'LOAD:GROUPS:CHARACTER'
  },
  STATES: {
    
    // Bootstrap app
    FRAMEWORK_LOADING: 'LOAD:STATES:FRAMEWORK_LOADING',
    FRAMEWORK_LOADED: 'LOAD:STATES:FRAMEWORK_LOADED',
    
    // GROUPS.MAIN
    MAIN_LOADING: 'LOAD:STATES:MAIN_LOADING',
    MAIN_LOADED: 'LOAD:STATES:MAIN_LOADED',
    
    // GROUPS.BUBBLE
    BUBBLE_LOADING: 'LOAD:STATES:BUBBLE_LOADING',
    BUBBLE_LOADED: 'LOAD:STATES:BUBBLE_LOADED',

    // GROUPS.CHARACTER
    CHARACTER_LOADING: 'LOAD:STATES:CHARACTER_LOADING',
    CHARACTER_LOADED: 'LOAD:STATES:CHARACTER_LOADED',
     
    COMPLETE: 'LOAD:STATES:COMPLETE'
  }
}

export const MODAL_STATES = {
  NONE: 'MODAL_STATE:NONE',
  MENU: 'MODAL_STATE:MENU',
  VIDEO: 'MODAL_STATE:VIDEO'
}

export const HOME = {
  SECTIONS: {
  	WELCOME: 'HOME:SECTION:WELCOME',
  	STAR_RATING_FIVE: 'HOME:SECTION:STAR_RATING_FIVE',
  	STAR_RATING_FOUR: 'HOME:SECTION:STAR_RATING_FOUR',
  	STAR_RATING_THREE: 'HOME:SECTION:STAR_RATING_THREE',
  	STAR_RATING_TWO: 'HOME:SECTION:STAR_RATING_TWO',
  	STAR_RATING_ONE: 'HOME:SECTION:STAR_RATING_ONE',
  	CTA: 'HOME:SECTION:CTA'
  },
  MODES: {
    DEFAULT: 'HOME:MODE:DEFAULT',
    MENU_EXPLORE: 'HOME:MODE:MENU_EXPLORE'
  }
}

export const EVENTS = {
  SCROLL_LOCK: 'EVENTS:SCROLL_LOCK',
  STOP_RENDER: 'EVENTS:STOP_RENDER',
  START_RENDER: 'EVENTS:START_RENDER',
  MOUSE_ENTER: 'EVENTS:MOUSE_ENTER',
  MOUSE_LEAVE: 'EVENTS:MOUSE_LEAVE'
}